export default "__VITE_ASSET__BNrCUfyu__"